// Custom popup that opens when a visitor clicks any link pointing to the
// configured anchor hash, e.g. <a href="/pages/imprint#guarantee-popup">.
// Markup is rendered by the cdl-anchor-popup section.
class CDLAnchorPopup extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.hash = (this.getAttribute('anchor-hash') || '').trim().replace(/^#/, '');

    this.addEventListener(
      'click',
      (this._onClick = (event) => {
        if (event.target.closest('[data-cdl-anchor-popup-dismiss]')) this.close();
      })
    );

    document.addEventListener(
      'click',
      (this._onDocumentClick = (event) => {
        if (!this.hash) return;
        const link = event.target.closest('a[href*="#"]');
        if (link && link.hash.slice(1) === this.hash) {
          event.preventDefault();
          this.open();
        }
      })
    );

    document.addEventListener(
      'keydown',
      (this._onKeydown = (event) => {
        if (event.key === 'Escape' && this.hasAttribute('open')) this.close();
      })
    );
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
    document.removeEventListener('click', this._onDocumentClick);
    document.removeEventListener('keydown', this._onKeydown);
    document.documentElement.classList.remove('cdl-anchor-popup-locked');
    this._initialized = false;
  }

  open() {
    this.setAttribute('open', '');
    document.documentElement.classList.add('cdl-anchor-popup-locked');
    this.querySelector('.cdl-anchor-popup__close')?.focus({ preventScroll: true });
  }

  close() {
    this.removeAttribute('open');
    document.documentElement.classList.remove('cdl-anchor-popup-locked');
  }
}

customElements.define('cdl-anchor-popup', CDLAnchorPopup);
